import React from 'react';
import { Link } from 'react-router-dom';

const Revocation = () => {
  return (
    <div className="container mx-auto px-4 py-8 max-w-4xl">
      <div className="bg-white rounded-lg shadow-lg p-8">
        <div className="mb-6">
          <Link to="/" className="text-blue-600 hover:text-blue-800 flex items-center mb-4">
            ← Zurück zum Formular
          </Link>
          <h1 className="text-3xl font-bold text-gray-900 mb-6">Widerrufsbelehrung</h1>
          
          <div className="prose max-w-none text-gray-700 space-y-4">
            <h2 className="text-xl font-semibold text-gray-900 mt-6">für Verbraucher gemäß § 355 BGB</h2>
            
            <h3 className="text-lg font-semibold text-gray-900 mt-4">Widerrufsrecht</h3>
            <p>
              Sie haben das Recht, binnen 14 Tagen ohne Angabe von Gründen diesen Vertrag zu widerrufen. Die Widerrufsfrist beträgt 14 Tage ab dem Tag des Vertragsabschlusses.
            </p>
            <p>
              Um Ihr Widerrufsrecht auszuüben, müssen Sie uns
            </p>
            <div className="bg-gray-50 p-4 rounded-md my-4">
              <strong>Nadine Rau u. Mike Trepte GbR</strong><br />
              Bettenhäuserstraße 1<br />
              34123 Kassel<br />
              E-Mail: <a href="mailto:mike.trepte@managershop.com" className="text-blue-600 hover:underline">mike.trepte@managershop.com</a>
            </div>
            <p>
              mittels einer eindeutigen Erklärung (z. B. per Brief oder E-Mail) über Ihren Entschluss informieren, diesen Vertrag zu widerrufen.
            </p>
            <p>
              Zur Wahrung der Frist genügt die rechtzeitige Absendung der Mitteilung.
            </p>
            
            <h3 className="text-lg font-semibold text-gray-900 mt-6">Folgen des Widerrufs</h3>
            <p>
              Wenn Sie den Vertrag widerrufen, erstatten wir alle Zahlungen, die wir von Ihnen erhalten haben, unverzüglich und spätestens innerhalb von 14 Tagen ab dem Tag, an dem die Mitteilung über Ihren Widerruf bei uns eingegangen ist. Für die Rückzahlung verwenden wir dasselbe Zahlungsmittel, das Sie bei der ursprünglichen Transaktion eingesetzt haben, es sei denn, mit Ihnen wurde ausdrücklich etwas anderes vereinbart.
            </p>
            
            <h3 className="text-lg font-semibold text-gray-900 mt-6">Widerruf bei Dienstleistungen / Online-Live-Veranstaltungen</h3>
            <p>
              Haben Sie verlangt, dass wir die Dienstleistung während der Widerrufsfrist beginnen, so haben Sie uns einen angemessenen Betrag zu zahlen, der dem Anteil der bis zu dem Zeitpunkt erbrachten Dienstleistungen entspricht, zu dem Sie uns über die Ausübung des Widerrufsrechts informieren.
            </p>
            
            <h3 className="text-lg font-semibold text-gray-900 mt-6">Vorzeitiges Erlöschen des Widerrufsrechts</h3>
            <p>
              Ihr Widerrufsrecht erlischt gemäß § 356 Abs. 4 BGB vorzeitig, wenn wir die Dienstleistung vollständig erbracht haben oder
            </p>
            <ul className="list-disc pl-5 space-y-1">
              <li>wenn wir mit Ihrer ausdrücklichen Zustimmung vor Ablauf der Widerrufsfrist mit der Ausführung der Dienstleistung beginnen, und</li>
              <li>Sie gleichzeitig Ihre Kenntnis bestätigt haben, dass Ihr Widerrufsrecht mit Beginn der Dienstleistung erlischt.</li>
            </ul>
            <p className="mt-2">
              Für unser Online-Programm bedeutet dies:
            </p>
            <ul className="list-disc pl-5 space-y-1">
              <li>Der Widerruf ist bis vor Beginn des ersten Termins möglich.</li>
              <li>Mit Beginn des ersten Termins erlischt Ihr Widerrufsrecht vollständig, sofern Sie der Ausführung ausdrücklich zugestimmt haben.</li>
            </ul>
            
            <h3 className="text-lg font-semibold text-gray-900 mt-6">Muster-Widerrufsformular</h3>
            <p>
              (Wenn Sie den Vertrag widerrufen wollen, füllen Sie bitte dieses Formular aus und senden Sie es zurück.)
            </p>
            
            <div className="border border-gray-300 p-6 rounded-md bg-gray-50 mt-4">
              <p>An</p>
              <p className="mb-4">
                Nadine Rau u. Mike Trepte GbR<br />
                Bettenhäuserstraße 1<br />
                34123 Kassel<br />
                E-Mail: mike.trepte@managershop.com
              </p>
              <p className="mb-2">Hiermit widerrufe(n) ich/wir (*) den Vertrag über die Erbringung der folgenden Dienstleistung (*):</p>
              <p className="mb-2">Bestellt am (*) / erhalten am (*)</p>
              <p className="mb-2">Name des/der Verbraucher(s):</p>
              <p className="mb-4">Anschrift des/der Verbraucher(s):</p>
              <div className="border-b border-gray-400 w-64 mb-1"></div>
              <p className="text-sm mb-4">Unterschrift (nur bei Mitteilung auf Papier)</p>
              <p>Datum:</p>
              <p className="text-sm mt-4">(*) Unzutreffendes streichen.</p>
            </div>
            
            <p className="mt-8 text-sm text-gray-500">Stand: November 2025</p>
          </div>
          
          <div className="mt-8 pt-6 border-t border-gray-200">
            <Link 
              to="/" 
              className="inline-flex items-center text-blue-600 hover:text-blue-800 font-medium"
            >
              ← Zurück zur Hauptseite
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Revocation;